<template>
  <el-card shadow="never" class="statistics-card">
    <el-radio-group v-model="tabs" @change="handleChangeType">
      <el-radio-button label="today">今日</el-radio-button>
      <el-radio-button label="yesterday">昨日</el-radio-button>
      <el-radio-button label="week">本周</el-radio-button>
      <el-radio-button label="month">本月</el-radio-button>
      <el-radio-button label="year">今年</el-radio-button>
    </el-radio-group>
    <el-row :gutter="0" style="margin-top: 16px">
      <el-col :span="6">
        <div>{{ titles.total }}</div>
        <div class="body">
          <span class="num">{{ statics.drugOrderTotal || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>{{ titles.done }}</div>
        <div class="body">
          <span class="num">{{ statics.drugOrderRegistrationNum || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>{{ titles.todo }}</div>
        <div class="body">
          <span class="num">{{ statics.drugOrderNoRegistrationNum || 0 }}</span>
          <span class="unit">条</span>
          <span class="tip" v-if="statics.unRegisteredCorrectionNum">
            <i class="el-icon-warning-outline"></i>
            已校正{{ statics.unRegisteredCorrectionNum }}条
          </span>
        </div>
      </el-col>
      <el-col :span="6" v-if="tabs !== 'yesterday'">
        <div>{{ titles.progress }}</div>
        <div class="body">
          <span class="num">{{ statics.drugOrderWaitRegistrationNum || 0 }}</span>
          <span class="unit">条</span>
          <span class="tip" v-if="statics.toRegisteredCorrectionNum">
            <i class="el-icon-warning-outline"></i>
            已校正{{ statics.toRegisteredCorrectionNum }}条
          </span>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import fetch from '@/api';

const type2Datetime = type => {
  switch (type) {
    case 'today': {
      return {
        orderStartTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'yesterday': {
      const yesterday = dayjs().subtract(1, 'days');
      return {
        orderStartTime: yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'week':
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'month':
      return {
        orderStartTime: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'year':
      return {
        orderStartTime: dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      };
    default:
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
  }
};

export default {
  name: 'staticsCard',
  props: {
    type: {
      type: String,
      // e.g. fourClass special prescription
      default: 'fourClass'
    }
  },
  data() {
    return { tabs: 'today', statics: {} };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    },
    titles() {
      const { type } = this;

      const titleMap = {
        fourClass: {
          total: '四类药品销售总数',
          done: '已登记',
          todo: '未登记',
          progress: '待登记'
        },
        special: { total: '特殊药品销售总数', done: '已登记', todo: '未登记', progress: '待登记' },
        prescription: { total: '处方药品销售总数', done: '凭处方销售', todo: '未凭处方销售', progress: '待上传' }
      };

      return titleMap[type];
    }
  },
  mounted() {
    this.fetchStaticsData();
  },
  methods: {
    handleChangeType() {
      this.fetchStaticsData();
    },
    fetchStaticsData() {
      const { type } = this;

      const { storeId, tabs } = this;
      const { orderStartTime: startTime, orderEndTime: endTime } = type2Datetime(tabs);

      const apiMap = {
        fourClass: fetch.statics_drug_order,
        special: fetch.static_special_drug_order,
        prescription: fetch.pc_prescription_order_summary
      };

      apiMap[type]({ startTime, endTime, storeId }).then(res => {
        this.statics = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tip {
  display: inline-block;
  background: #ffedec;
  margin-left: 2px;
  border-radius: 2px;
  font-size: 12px;
  color: #ff4e47;
  line-height: 18px;
  padding: 0 4px;
  .el-icon-warning-outline {
    // padding-right: 4px;
    line-height: 20px;
  }
}
</style>
